import { render } from "./AdrDatadogHost.vue?vue&type=template&id=587b2e25"
import script from "./AdrDatadogHost.vue?vue&type=script&lang=js"
export * from "./AdrDatadogHost.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__